<div class="col-md-12" *ngIf="serverError">
  <div class="alert alert-danger centerText">
    {{ "error.server.not.reachable" | translate }}
  </div>
</div>
<div class="col-md-12 noBottomMargin noPaddingMd-12" *ngIf="isEmployee">
  <img class="homeImg" width="100%" src="assets/images/ppm/Home.jpg" />
  <div class="col-md-12 outer-cover-home">
    <div class="col-md-4"></div>
    <div *ngIf="isEmployee">
      <div class="col-md-4 innerProfile" id="whiteBackground" *ngIf="profile">
        <h2 class="profileMainHeader">
          {{ "person.personalinformation" | translate }}
        </h2>
        <p class="profileContent">
          <label class="profileHeading">
            {{ "person.certificatenumber" | translate }}
          </label>
        </p>
        <p class="profileContent">
          {{ profile.certificateNumber }}
        </p>
        <p class="profileContent">
          <label class="profileHeading">
            {{ "person.name" | translate }}
          </label>
        </p>
        <p class="profileContent">
          {{ profile.name }}
        </p>
        <p class="profileContent">
          <label class="profileHeading">
            {{ "person.nik" | translate }}
          </label>
        </p>
        <p class="profileContent">
          {{ profile.employeeId }}
        </p>
        <p class="profileContent">
          <label class="profileHeading">
            {{ "person.dateofbirth" | translate }}
          </label>
        </p>
        <p class="profileContent">
          {{ profile.dateOfBirth }}
        </p>
        <p class="profileContent">
          <label class="profileHeading">
            {{ "person.retirementdate" | translate }}
          </label>
        </p>
        <p class="profileContent">
          {{ profile.retirementDate }}
        </p>
        <p class="profileContent">
          <label class="profileHeading">
            {{ "person.pensionage" | translate }}
          </label>
        </p>
        <p class="profileContent">
          {{ profile.retirementAge }}
        </p>
        <p class="centerText">
          <button
            type="button"
            class="btn btn-outline-primary certDownlloadButton"
            (click)="downloadECertificateInit()"
          >
            <span class="glyphicon glyphicon-file-pdf"></span>
            Download E-Certificate
          </button>
        </p>
      </div>
    </div>
    <div class="col-md-4 noMobileMargin"></div>
    <div class="col-md-12 noMobileMargin">
      <div class="col-md-1 noMobileMargin">&nbsp;</div>
      <div class="col-md-2 homeEmpShortcut balanceEmpDiv">
        <a routerLink="faq">
          <div class="homeShortcutImg">
            <img class="faqImg" src="assets/images/ppm/faq.png" />
          </div>
          <div class="homeIconHeadingSmall">FAQ</div>
        </a>
      </div>
      <div class="col-md-2 homeEmpShortcut balanceEmpDiv">
        <a routerLink="balance">
          <div class="homeShortcutImg">
            <img class="opacImg" src="assets/images/ppm/balance.jpg" />
          </div>
          <div class="homeIconHeadingSmall">
            {{ "global.menu.balance" | translate }}
          </div>
        </a>
      </div>
      <div class="col-md-2 homeEmpShortcut">
        <a routerLink="fund">
          <div class="homeShortcutImg">
            <img src="assets/images/ppm/fp.png" class="opacImg" />
          </div>
          <div class="homeIconHeadingBig">
            {{ "transaction.fund" | translate }}
          </div>
        </a>
      </div>
      <div class="col-md-2 homeEmpShortcut balanceEmpDiv">
        <a routerLink="unitprice">
          <div class="homeShortcutImg">
            <img src="assets/images/ppm/up.jpg" class="opacImg" />
          </div>
          <div class="homeIconHeadingBig">
            {{ "global.menu.unit" | translate }}
          </div>
        </a>
      </div>
      <div class="col-md-2 homeEmpShortcut">
        <a routerLink="document">
          <div class="homeShortcutImg">
            <img class="downloadImg" src="assets/images/ppm/download.png" />
          </div>
          <div class="homeIconHeadingBig">
            {{ "global.menu.document" | translate }}
          </div>
        </a>
      </div>
      <div class="col-md-1">&nbsp;</div>
    </div>
  </div>
</div>
<div class="col-md-12 noBottomMargin noPaddingMd-12" *ngIf="isAdmin">
  <div class="col-md-12 noBottomMargin noPaddingMd-12 adminbanner"></div>
  <div class="col-md-12 outer-cover-home-admin noPaddingMd-12">
    <div class="col-md-2"></div>
    <div class="col-md-8 adminWelcomeDiv">
      <h1 class="adminWelcomText">
        {{ "global.welcome" | translate }} eAZy
        {{ "global.pension" | translate }}
      </h1>
    </div>
    <div class="col-md-2"></div>
<!-- home shorcut -->
<div class="col-md-12 adminShortcutMainDiv noPaddingMd-12 grid">
  <div class="col-md-1">&nbsp;</div>
  <div class="col-md-2 homeEmpShortcut balanceEmpDiv">
    <a routerLink="faq">
      <div class="homeShortcutImg">
        <img class="faqImg" src="assets/images/ppm/faq.png" />
      </div>
      <div class="homeIconHeadingSmall">FAQ</div>
    </a>
  </div>
  <div class="col-md-2 homeEmpShortcut balanceEmpDiv">
    <a routerLink="balance">
      <div class="homeShortcutImg">
        <img src="assets/images/ppm/balance.jpg" class="opacImg" />
      </div>
      <div class="homeIconHeadingSmall">
        {{ "global.menu.balance" | translate }}
      </div>
    </a>
  </div>
  <div class="col-md-2 homeEmpShortcut">
    <a routerLink="fund">
      <div class="homeShortcutImg">
        <img src="assets/images/ppm/fp.png" class="opacImg" />
      </div>
      <div class="homeIconHeadingBig">
        {{ "transaction.fund" | translate }}
      </div>
    </a>
  </div>
  <div class="col-md-2 homeEmpShortcut balanceEmpDiv">
    <a routerLink="unitprice">
      <div class="homeShortcutImg">
        <img src="assets/images/ppm/up.jpg" class="opacImg" />
      </div>
      <div class="homeIconHeadingSmall">
        {{ "global.menu.unit" | translate }}
      </div>
    </a>
  </div>
  <div class="col-md-2 homeEmpShortcut">
    <a routerLink="document">
      <div class="homeShortcutImg">
        <img class="downloadImg" src="assets/images/ppm/download.png" />
      </div>
      <div class="homeIconHeadingBig">
        {{ "global.menu.document" | translate }}
      </div>
    </a>
  </div>
  <div class="col-md-1">&nbsp;</div>
</div>

  </div>
  <div class="col-md-12 headerDiv">
    <form
      class="employee-search"
      [formGroup]="userSearchForm"
      novalidate
      (submit)="searchUserCeritificate()"
    >
      <div class="col-md-1"></div>
      <div class="col-md-2 searchIcon">
        <span class="glyphicon glyphicon-search"></span>
      </div>
      <div class="col-md-4 buttnfreemargin">
        <div class="login-form-group pmi_form_group">
          <input
            class="searchUser"
            type="search"
            id="certificatenumber"
            [(ngModel)]="searchString"
            name="certificatenumber"
            formControlName="certificateNumber"
            autocomplete="off"
            autofocus
            required
          />

          <!--
                        <span class="highlight"></span>
          -->
          <span class="bar"></span>
          <label class="adminLabel">{{
            "home.form.searchparam" | translate
          }}</label>
        </div>
      </div>
      <div class="col-md-1 clearSearch">
        <button
          type="button"
          class="close customClose"
          aria-label="Close"
          (click)="clearSearchData()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col-md-2">
        <button
          type="submit"
          class="btn btn-primary btnsearch"
          [disabled]="!userSearchForm.valid"
        >
          {{ "document.search" | translate }}
        </button>
      </div>
      <div class="col-md-2"></div>
    </form>
  </div>
  <div class="col-md-12">
    <div class="col-md-1"></div>
    <div class="col-md-10 tableDiv">
      <table class="table table-scrollable userTable">
        <thead>
          <tr>
            <th colspan="2">
              {{ "person.certificatenumber" | translate }}
            </th>
            <th colspan="2">
              {{ "person.company" | translate }}
            </th>
            <th colspan="2">
              {{ "person.name" | translate }}
            </th>
            <th colspan="2">
              {{ "person.nik" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="rowBorder" *ngIf="userFound">
            <td colspan="2">{{ userDetails.certificateNumber }}</td>
            <td colspan="2" style="vertical-align: middle; text-align: left">
              {{ userDetails.companyName }}
            </td>
            <td colspan="2">{{ userDetails.participantName }}</td>
            <td colspan="2">{{ userDetails.employeeId }}</td>
          </tr>
          <tr class="rowBorder centerText" *ngIf="userNotFound">
            <td colspan="8">No user found</td>
          </tr>
          <tr class="rowBorder centerText" *ngIf="userSearch">
            <td colspan="8">{{ "person.searchfor" | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-1"></div>
    <div class="col-md-12" *ngIf="userFound">
      <div class="col-md-4 noBottomMargin"></div>
      <div class="col-md-4 noBottomMargin">
        <button
          type="button"
          class="btn btn-primary"
          (click)="downloadECertificateInit()"
        >
          <span class="glyphicon glyphicon-file-pdf"></span>
          <strong>Download E-Certificate</strong>
        </button>
      </div>
      <div class="col-md-4 noBottomMargin"></div>
    </div>
  </div>
</div>
<section>

  <bs-modal #introModal [keyboard]="false" [backdrop]="'static'">
    <bs-modal-body>
      <div>
        <h4 class="modal-text text-center">{{'mfa.termsCondition' | translate}}</h4>
        <p class="modal-text text-center">{{'mfa.supportEnhancement' | translate}}</p>

        <div class="modal-text text-center" style="padding-top: 2rem;">
          <button class="btn btn-primary" (click)="introModalButton()">{{'mfa.ok' | translate}}</button>
        </div>
      </div>
    </bs-modal-body>
  </bs-modal>

  <bs-modal #registerDeviceModal [keyboard]="false" [backdrop]="'static'">
    <bs-modal-body>
      <div>
        <h4 class="modal-text text-center">{{'mfa.registerDevice' | translate}}</h4>
        <p class="modal-text text-center">{{'mfa.sureToRegisterDevice' | translate}}</p>
        <p class="modal-text text-center">{{'mfa.nextTimeLogin' | translate}}</p>

      <div class="modal-text text-centert" style="display: flex;justify-content: center; gap: 2rem; padding-top: 2rem;">
        <button class="btn btn-warning" (click)="registerDeviceButton(0)">{{'mfa.no' | translate}}</button>
        <button class="btn btn-primary" (click)="registerDeviceButton(1)">{{'mfa.ok' | translate}}</button>
      </div>
      </div>
    </bs-modal-body>
  </bs-modal>

  <bs-modal #thankYouModal [keyboard]="false" [backdrop]="'static'">
    <bs-modal-body>
      <div>
        <h4 class="modal-text text-center">{{'mfa.thankYouToRegister' | translate}}</h4>
        <div class="modal-text text-center" style="display: flex;justify-content: center; gap: 2rem; padding-top: 2rem;">
          <button class="btn btn-primary" (click)="thankYouButton()">{{'mfa.ok' | translate}}</button>
        </div>
      </div>
    </bs-modal-body>
  </bs-modal>

</section>
